import React, {useState} from "react";
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {
    Box,
    Button, Card, Modal,
    TextField,
    Typography,
} from "@material-ui/core";
import clsx from "clsx";
import NoImage from "../../../common/images/NoImage.jpg";
import {ReactComponent as ProgressClose} from '../../../common/images/ProgressClose.svg';
import {ReactComponent as TranslationRefreshIcon} from '../../../common/images/TranslationRefreshIcon.svg';
import {useStyles} from "./styles/NoticeStyle";
import {NoticeLangName} from "../../../common/enums/ContentEnum";
import {USER_TYPE} from "../../../stores/UserStore";
import {NotificationType} from "../../../stores/NoticeStore";

function NoticeContent(props) {
    const classes = useStyles();
    const content = 'content';
    const {intl} = props;
    const {noticeStore, localeStore} = props;
    const [open, setOpen] = useState(false);
    const userType = props.authStore.getUserType();

    const handleOpenPreview = () => {
        setOpen(true);
    };

    const handleClosePreview = () => {
        setOpen(false);
    };

    const handleChangeContent = (event) => {
        noticeStore.setContent(event.target.value);

    }

    const translateAll = () => {
        const lang = localeStore.locale.toUpperCase();
        let text = noticeStore.content;
        noticeStore.translateAllNotice(lang, text, content, noticeStore.setNoticeTranslations);
    }

    const handleRefreshTranslationText = (translation, index) => {
        const languageCode = translation.languageCode;
        const text = noticeStore.content;
        noticeStore.translateNotice(index, languageCode, localeStore.locale.toUpperCase(), text, content, noticeStore.setNoticeElement)
    }

    const handleTextChange = (event, translation) => {
        const newText = event.target.value;
        translation[content] = newText;
    };

    const openFileExplorer = () => {
        const input = document.getElementById('ImageUpload');
        input.click();
    }

    const handleClickRemoveImage = (index) => {
        noticeStore.initDetailImage(index);
        console.log(`Delete Uploaded ${index} Image`);
    }

    const uploadImage = async (e) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            try {
                const currentLength = noticeStore.detailImages.length;
                const remainingSlots = 5 - currentLength;
                const numberOfImagesToAdd = Math.min(files.length, remainingSlots);

                if (numberOfImagesToAdd < files.length) {
                    alert(`${intl.formatMessage({id: "AddImageAlert"})}`);
                }

                for (let i = 0; i < numberOfImagesToAdd; i++) {
                    const file = files[i];
                    const fileType = file.type.split('/')[1];
                    const base64String = await convertFileToBase64(file);

                    const newImage = {
                        image: `data:image/${fileType};base64,` + base64String,
                        sequence: 0,
                        originalFileName: file.name.split(".").slice(0, -1).join("."),
                        originalFileExtension: fileType
                    };
                    noticeStore.pushDetailImages(newImage);
                }
            } catch (error) {
                console.error('Error converting Image file to base64:', error);
            }
        }
    }

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                resolve(reader.result.split(',')[1]);
            };

            reader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const translatingBox = (translation, index) => {
        const languageCode = translation.languageCode;
        return (
            <React.Fragment key={index}>
                {noticeStore.getCurrentIndexWithLangCode(localeStore.locale.toUpperCase()) !== index &&
                    <div key={index}>
                        <Box display={'flex'} justifyContent={'flex-start'} className={classes.translationTitle}>
                            <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}
                                 style={{width: '10%'}} paddingTop={1}>
                                <Typography
                                    className={classes.langText}>{NoticeLangName[localeStore.locale.toUpperCase()][languageCode]}</Typography>
                                <Button disableRipple onClick={() => handleRefreshTranslationText(translation, index)}>
                                    <TranslationRefreshIcon/>
                                </Button>
                            </Box>
                        </Box>
                        <Box>
                            <TextField
                                id="outlined-multiline-static"
                                placeholder={intl.formatMessage({id: "TextPlaceholder"})}
                                multiline
                                maxRows={6}
                                variant="outlined"
                                value={translation[content]}
                                onChange={(event) => handleTextChange(event, translation)}
                                style={{ overflowY: 'auto' }}
                            />
                        </Box>
                    </div>
                }
            </React.Fragment>
        )
    }

    const disableContent = !noticeStore.content;

    return (
        <Box>
            {/* 내용 */}
            <Box display={"flex"} justifyContent={"space-between"} marginTop={3} marginBottom={3}>
                <Typography
                    style={{fontWeight: 'bold', fontSize: '1rem'}}>{intl.formatMessage({id: "Content"})}</Typography>
            </Box>
            {/* 내용 박스 */}
            <Box className={clsx(classes.boxWrap)}>
                <Box display={"flex"} flexDirection={"row"}>
                    <Box display={"flex"} flexDirection={"row"} style={{flex: 1}} justifyContent={"flex-start"}
                         marginBottom={2}>
                        <Box height={80} display={"flex"} alignItems={"center"} marginRight={2}>
                            <Typography
                                style={{
                                    fontWeight: 'bold',
                                    fontSize: '1rem'
                                }}>{intl.formatMessage({id: "ImageMax"})}</Typography>
                        </Box>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <Button className={classes.setButton} disableRipple onClick={openFileExplorer}>
                                <Typography>{intl.formatMessage({id: "register"})}</Typography>
                            </Button>
                        </Box>
                        <input id={'ImageUpload'} style={{display: 'none'}} accept={".jpg, .jpeg, .png"}
                               onChange={uploadImage} placeholder={intl.formatMessage({id: "full_file"})}
                               type={'file'} multiple/>
                        <Box style={{
                            padding: '10px 15px',
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            {noticeStore.detailImages.map((image, index) => (
                                <Box key={index} style={{marginRight: '10px'}} display={"flex"} alignItems={"center"}>
                                    {noticeStore.detailImages[index].image ? (
                                        <Box display={"flex"} flexDirection={"column"}
                                             style={{width: '60px', height: '60px'}}>
                                            <Box display={"flex"} justifyContent={"flex-end"}
                                                 onClick={() => handleClickRemoveImage(index)}>
                                                <ProgressClose style={{width: '15px', height: '15px'}}/>
                                            </Box>
                                            <Box>
                                                <img style={{width: '45px', height: '45px'}}
                                                     src={noticeStore.detailImages[index].image}
                                                     alt={`이미지 ${index + 1}`}/>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <img className={classes.iconBtn} style={{width: '45px', height: '45px'}}
                                             src={NoImage} alt='NoImage'/>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
                {/* 내용 */}
                <Box>
                    <Box className={clsx(classes.textBox, classes.contentBoxTranslation)}>
                        <TextField
                            id="outlined-static-title"
                            placeholder={`${intl.formatMessage({id: "ContentPlaceholder"})}`}
                            variant="outlined"
                            multiline
                            maxRows={6}
                            value={noticeStore.content}
                            onChange={handleChangeContent}
                            style={{ overflowY: 'auto' }}
                        />
                        <Box display={"flex"} flexDirection={"row"} justifyContent={"flex-end"}>
                            {userType === USER_TYPE.Admin && noticeStore.selectOption === NotificationType.All ? (
                                <Box marginRight={2}>
                                    <Button
                                        disabled={disableContent}
                                        style={{borderColor: disableContent ? 'gray' : '#7445FF'}}
                                        variant={'outlined'}
                                        onClick={translateAll}
                                    >
                                        <Typography
                                            style={{color: disableContent ? 'gray' : '#7445FF'}}>{intl.formatMessage({id: "translation"})}</Typography>
                                    </Button>
                                </Box>
                            ) : null}
                            <Box>
                                <Button
                                    style={{borderColor: '#7445FF'}}
                                    variant={'outlined'}
                                    onClick={handleOpenPreview}
                                >
                                    <Typography
                                        style={{color: '#7445FF'}}>{intl.formatMessage({id: "Preview"})}</Typography>
                                </Button>
                                <Modal
                                    open={open}
                                    onClose={handleClosePreview}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box>
                                        <Card style={{
                                            width: '380px',
                                            height: '680px',
                                            backgroundColor: "white",
                                            border: '1px solid black',
                                        }}>
                                            <Box display={"flex"} flexDirection={"column"}>
                                                <Box display={"flex"} justifyContent={"space-between"}>
                                                    <Box alignItems={"center"} marginLeft={1} marginTop={1}>
                                                        <Typography>{intl.formatMessage({id: "Preview"})}</Typography>
                                                    </Box>
                                                    <Box onClick={handleClosePreview}>
                                                        <ProgressClose style={{width: '30px', height: '30px'}}/>
                                                    </Box>
                                                </Box>
                                                <Box borderBottom="1px solid black" width="100%" my={1}/>
                                                <Box display={"flex"} flexDirection={"column"} justifyContent={"center"}
                                                     alignItems={"center"} marginTop={1}>
                                                    <Box style={{
                                                        width: '320px',
                                                        height: '580px',
                                                        backgroundColor: "#F7F7F7"
                                                    }} display={"flex"} flexDirection={"column"}>
                                                        <Box display={"flex"} justifyContent={"center"}
                                                             marginBottom={1}>
                                                            {noticeStore.title && <Typography
                                                                style={{fontWeight: 'bold', fontSize:'20px'}}>{noticeStore.title}</Typography>}
                                                        </Box>
                                                        <Box display={"flex"} justifyContent={"center"}
                                                             marginBottom={1}>
                                                            {noticeStore.detailImages.length !== 0 ? (
                                                                <Box display={"flex"} flexDirection={"column"}>
                                                                    <Box>
                                                                        <img style={{width: 'auto', height: '190px'}}
                                                                             src={noticeStore.detailImages[noticeStore.previewIndex].image}
                                                                             alt={`이미지 ${noticeStore.previewIndex + 1}`}/>
                                                                    </Box>
                                                                </Box>
                                                            ) : null}
                                                        </Box>
                                                        <Box display={"flex"} justifyContent={"center"}>
                                                            {noticeStore.content &&
                                                                <Typography style={{whiteSpace: 'pre-line'}}>{noticeStore.content}</Typography>}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Card>
                                    </Box>
                                </Modal>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {userType === USER_TYPE.Admin && noticeStore.selectOption === NotificationType.All ? (
                <Box>
                    <Box className={classes.boxBottomTranslation}>
                        {noticeStore.noticeContents.length > 0 && noticeStore.noticeContents.map((list, index) => {
                            if (list.languageCode !== localeStore.locale.toUpperCase()) {
                                return translatingBox(list, index);
                            } else {
                                return null;
                            }
                        })}
                    </Box>
                </Box>
            ) : null}
        </Box>
    )
}

export default inject('authStore', 'noticeStore', 'localeStore')(injectIntl(observer(NoticeContent)));